module.exports = __webpack_public_path__ + "d6070fbbf94372457c3beaa1a7e9af73.svg";